// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","name":"Card_name__Qjf9y","card_close":"Card_card_close__U+Mfq","details":"Card_details__ez44D","cardImage":"Card_cardImage__O5c+i"};